import { render } from "./PropertySection.vue?vue&type=template&id=40e9a536&scoped=true"
import script from "./PropertySection.vue?vue&type=script&lang=js"
export * from "./PropertySection.vue?vue&type=script&lang=js"

import "./PropertySection.vue?vue&type=style&index=0&id=40e9a536&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e9a536"]])

export default __exports__